import { render } from "./SizeForm.vue?vue&type=template&id=716186a5&scoped=true"
import script from "./SizeForm.vue?vue&type=script&lang=js"
export * from "./SizeForm.vue?vue&type=script&lang=js"

import "./SizeForm.vue?vue&type=style&index=0&id=716186a5&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716186a5"]])

export default __exports__